export const userType = () =>
    (localStorage.getItem("user_type") || "").toUpperCase();

export const isOwner = () => userType() === "O";

export const isAdmin = () => userType() === "A";

export const isAdminOrOwner = () => {
    const t = userType();
    return t === "O" || t === "A";
};